<template>
    <el-dialog
        v-model="dialogVisible"
        width="600px"
        center
        :close-on-click-modal="false"
    >
        <div class="bingli_Dialog" id="medicalRecordPrintArea">
            <!-- 门诊病历详情沿用开方页历史病历弹窗的展示结构。 -->
            <div class="pay_loading_con flex_c_col" v-if="isLoadingPatient">
                <el-icon class="pay_loading_icon is-loading">
                    <loading />
                </el-icon>
                <div class="pay_loading_text">正在查询，请稍候...</div>
            </div>

            <template v-if="recordLoaded">
                <div class="bingli_title_con">
                    <div class="bingli_title">知夏中医门诊部</div>
                    <div class="bingli_title">门诊病历</div>
                </div>
                <div class="bingli_line flex_c_col">
                    <div class="width100">
                        <span class="mrr20"><span class="font_weight">就诊时间：</span>{{
                            formatValue(bingliMedicalOrder.createTime)
                        }}</span>
                        <span class="mrr20"><span class="font_weight">就诊科室：</span>知夏中医门诊</span>
                        <span class="mrr20"><span class="font_weight">就诊类型：</span>{{
                            bingliMedicalOrder.isFirstVisit === '0' ? '初诊' : '复诊'
                        }}</span>
                    </div>
                    <div class="width100">
                        <span class="mrr20"><span class="font_weight">就诊处方号：</span>{{
                            formatValue(bingliMedicalOrder.serialNo)
                        }}</span>
                    </div>
                </div>
                <div class="bingli_line flex_left_warp">
                    <div class="width100 flex_c_left">
                        <span class="flex_c_left mrr20"><span class="font_weight">姓名：</span>{{
                            formatValue(bingliInfo.name)
                        }}</span>
                        <span class="flex_c_left mrr20"><span class="font_weight">性别：</span>{{
                            bingliInfo.sex === '0' ? '男' : bingliInfo.sex === '1' ? '女' : '未知'
                        }}</span>
                        <span class="flex_c_left mrr20"><span class="font_weight">年龄：</span>{{
                            bingliInfo.age === null || bingliInfo.age === undefined ? '--' : bingliInfo.age
                        }}岁</span>
                        <span class="flex_c_left mrr20"><span class="font_weight">手机号码：</span>{{
                            formatValue(bingliInfo.phoneNumber, '--')
                        }}</span>
                    </div>
                    <div class="width100 flex_c_left">
                        <div class="flex_c_left mrr20">
                            <span><span class="font_weight">身份证号：</span>{{ identityText }}</span>
                        </div>
                        <div class="flex_c_left mrr20">
                            <span><span class="font_weight">家庭住址：</span>{{
                                formatValue(bingliInfo.province)
                            }}</span>
                        </div>
                    </div>
                    <div class="width100"><span class="font_weight">主诉：</span>{{
                        formatValue(bingliMedicalOrder.mainSuit)
                    }}</div>
                    <div class="width100"><span class="font_weight">现病史：</span>{{
                        formatValue(bingliMedicalOrder.nowMedicalHistory)
                    }}</div>
                    <div class="width100"><span class="font_weight">既往史：</span>{{
                        formatValue(bingliMedicalOrder.patientMedicalHistory)
                    }}</div>
                    <div class="width100"><span class="font_weight">过敏史：</span>{{
                        formatValue(bingliMedicalOrder.patientOperationHistory)
                    }}</div>
                    <div class="width100"><span class="font_weight">临床诊断：</span>{{
                        formatValue(bingliMedicalOrder.clinicalDiagnosis)
                    }}</div>
                    <div class="width100"><span class="font_weight">检查记录：</span>{{
                        formatValue(bingliMedicalOrder.inspectionRecord)
                    }}</div>
                    <div class="width100"><span class="font_weight">处理意见：</span>中药治疗</div>
                </div>
                <div class="bingli_line flex_bot_between">
                    <div class="paper_line_left_left flex_c_left"></div>
                    <div class="paper_line_left flex_c_right">
                        <div class="paper_left">门诊医生：</div>
                        <div class="paper_right">
                            <el-image
                                v-if="doctorInfo.signPic"
                                style="height: 42px"
                                :src="tencentCosUrl + doctorInfo.signPic"
                                fit="cover"
                            />
                        </div>
                    </div>
                </div>
            </template>
            <el-empty v-if="loadFailed" description="门诊病历查询失败" />
            <el-empty v-else-if="!isLoadingPatient && !recordLoaded" description="暂无门诊病历信息" />
        </div>

        <template #footer>
            <div class="dialog-footer no-print">
                <el-button @click="closeDialog">取消</el-button>
                <el-button type="primary" :disabled="!recordLoaded" v-print="printBingliInfoObj">打印</el-button>
            </div>
        </template>
    </el-dialog>
</template>

<script>
import {getMedicalOrderDetail} from "@/api";
import baseConfig from "@/api/config";
import {message} from "@/assets/utils/common";

export default {
    name: "MedicalRecordDialog",
    props: {
        modelValue: {
            type: Boolean,
            default: false
        },
        orderId: {
            type: [String, Number],
            default: null
        }
    },
    emits: ["update:modelValue"],
    data() {
        return {
            tencentCosUrl: baseConfig.tencentCosUrl,
            doctorInfo: {},
            isLoadingPatient: false,
            recordLoaded: false,
            requestId: 0,
            requestOrderId: null,
            loadFailed: false,
            bingliInfo: {},
            bingliMedicalOrder: {},
            printBingliInfoObj: {
                id: "medicalRecordPrintArea",
                popTitle: "知夏中医门诊部门诊病历",
                extraHead: "",
                preview: "false",
                previewTitle: "知夏中医门诊部门诊病历",
                previewPrintBtnLabel: "",
                zIndex: "",
                previewBeforeOpenCallback() {},
                previewOpenCallback() {},
                beforeOpenCallback() {},
                openCallback() {},
                closeCallback() {},
                url: "",
                standard: "",
                extraCss: ""
            }
        };
    },
    computed: {
        dialogVisible: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            }
        },
        identityText() {
            const identity = this.bingliInfo.identity;
            if (identity === null || identity === undefined || identity === "") {
                return "--";
            }
            return identity.substr(0, 5) + "**********" + identity.substr(14, identity.length);
        }
    },
    watch: {
        modelValue(visible) {
            if (visible) {
                this.loadMedicalRecord();
            }
        },
        orderId() {
            if (this.modelValue) {
                this.loadMedicalRecord();
            }
        }
    },
    created() {
        const savedDoctorInfo = window.sessionStorage.getItem("doctorInfo");
        if (savedDoctorInfo) {
            try {
                this.doctorInfo = JSON.parse(savedDoctorInfo) || {};
            } catch (error) {
                console.warn("读取医生信息失败，门诊病历将不展示医生签名", error);
            }
        }
    },
    methods: {
        formatValue(value, emptyText = "暂无") {
            return value === null || value === undefined || String(value).trim() === "" ? emptyText : value;
        },

        loadMedicalRecord() {
            if (this.orderId === null || this.orderId === undefined || String(this.orderId).trim() === "") {
                message("当前历史记录缺少病历标识", "error");
                this.closeDialog();
                return;
            }
            if (this.isLoadingPatient && String(this.requestOrderId) === String(this.orderId)) {
                return;
            }

            const requestId = ++this.requestId;
            const requestOrderId = this.orderId;
            this.requestOrderId = requestOrderId;
            this.isLoadingPatient = true;
            this.recordLoaded = false;
            this.loadFailed = false;
            getMedicalOrderDetail(requestOrderId).then(response => {
                if (requestId !== this.requestId || String(requestOrderId) !== String(this.orderId)) {
                    return;
                }
                if (response.data.code !== 200 || !response.data.data) {
                    this.loadFailed = true;
                    message("门诊病历查询失败", "error");
                    return;
                }
                this.bingliInfo = response.data.data.docPatientProfile || {};
                this.bingliMedicalOrder = response.data.data.medicalOrder || {};
                if (this.bingliMedicalOrder.patientOperationHistory === undefined && this.bingliMedicalOrder.allergyHistory !== undefined) {
                    this.bingliMedicalOrder.patientOperationHistory = this.bingliMedicalOrder.allergyHistory;
                }
                this.recordLoaded = true;
            }).catch(() => {
                if (requestId === this.requestId) {
                    this.loadFailed = true;
                    message("门诊病历查询失败", "error");
                }
            }).finally(() => {
                if (requestId === this.requestId) {
                    this.isLoadingPatient = false;
                }
            });
        },

        closeDialog() {
            this.dialogVisible = false;
        }
    }
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/style.scss";
</style>
